import PaymentForm from "components/Form/PaymentForm";

const PAYMENT_TYPE = 1;

export default function StepSixForm() {
    return <PaymentForm type={PAYMENT_TYPE}/>;
}